export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const headerH = 64;
      const top = el.getBoundingClientRect().top + window.scrollY - headerH;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-300/30">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="text-xl font-extrabold tracking-tight text-primary-500 mb-4">
              91<span className="text-foreground-50">精品影视</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              91精品影视免费在线观看平台，提供高清不缓冲的影视看片体验。覆盖海量电影、电视剧、动漫、综艺资源，每日更新，91影视在线看片随时随地畅享流畅观影。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="hover:text-primary-400 transition-colors cursor-pointer"
              >
                快速导航
              </a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '专题合集', href: '#index' },
                { label: '最新更新', href: '#updates' },
                { label: '热度榜单', href: '#ranking' },
                { label: '精彩预告', href: '#media' },
                { label: '精选内容', href: '#cards' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a
                href="#about"
                onClick={(e) => handleNavClick(e, '#about')}
                className="hover:text-primary-400 transition-colors cursor-pointer"
              >
                平台服务
              </a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '关于我们', href: '#about' },
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '移动端体验', href: '#app' },
                { label: '热门话题', href: '#topics' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-300/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 91精品影视. 本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}